<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 2.55005L11 8.05005V6.45005L5.5 0.950049L0 6.45005V8.05005L5.5 2.55005Z" fill="#0063D3" />
</svg>
